import { useEffect } from 'react';

import { useCommandPaletteContext } from '@/app/surfaces/command-palette-provider.js';
import { useFormDrawerContext } from '@/app/surfaces/form-drawer-provider.js';
import { useQuickPanelContext } from '@/app/surfaces/quick-panel-provider.js';
import { quickPanelRegistry } from '@/app/surfaces/quick-panel-registry.js';

function isModKey(event: KeyboardEvent): boolean {
  return event.metaKey || event.ctrlKey;
}

export function SurfaceShortcuts() {
  const { isOpen, toggleCommandPalette, closeCommandPalette } = useCommandPaletteContext();
  const { stack, dismissTopQuickPanel, toggleQuickPanel } = useQuickPanelContext();
  const { stack: formDrawerStack, closeFormDrawer } = useFormDrawerContext();

  useEffect(() => {
    function handleKeyDown(event: KeyboardEvent) {
      if (isModKey(event) && event.key.toLowerCase() === 'k') {
        event.preventDefault();
        toggleCommandPalette();
        return;
      }

      if (event.key === 'Escape') {
        if (isOpen) {
          event.preventDefault();
          closeCommandPalette();
          return;
        }

        const topQuickPanel = stack.at(-1);
        if (topQuickPanel && !topQuickPanel.pinned) {
          event.preventDefault();
          dismissTopQuickPanel();
          return;
        }

        if (formDrawerStack.length > 0) {
          event.preventDefault();
          closeFormDrawer();
        }

        return;
      }

      if (event.altKey && !event.metaKey && !event.ctrlKey && !event.shiftKey) {
        const shortcut = Number(event.key);
        if (shortcut >= 1 && shortcut <= 5) {
          const entry = Object.entries(quickPanelRegistry).find(
            ([, panel]) => panel.shortcut === shortcut,
          );

          if (entry) {
            event.preventDefault();
            toggleQuickPanel(entry[0]);
          }
        }
      }
    }

    window.addEventListener('keydown', handleKeyDown);
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [
    closeCommandPalette,
    closeFormDrawer,
    dismissTopQuickPanel,
    formDrawerStack.length,
    isOpen,
    stack,
    toggleCommandPalette,
    toggleQuickPanel,
  ]);

  return null;
}
